<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Скидки"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление скидки</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="12">
                      <v-text-field
                        v-model="editedItem.discountValue"
                        label="Значение скидки"
                      />
                      <v-text-field
                        v-model="editedItem.promoCode"
                        label="Промокод"
                      />
                      <v-card>
                        <v-card-title>Подарок к промокоду</v-card-title>
                        <v-card-text>
                          <relations :open-dialog="dialog" :default="offersFormatted" @change="selectOffer" v-if="offersFormatted"/>
                        </v-card-text>
                      </v-card>
                      <v-text-field
                        v-model="editedItem.minOrderPrice"
                        label="Мин. сумма заказа"
                      />
                      <v-text-field
                        v-model="editedItem.maxOrderPrice"
                        label="Макс. сумма заказа"
                      />
                      <v-text-field
                        v-model="editedItem.moreThanNItems"
                        label="Скидка при кол-ве товаров"
                      />
                      <v-checkbox
                        v-model="editedItem.isNthFreeDiscount"
                        label="3,6-й бесплатно"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="editedItem.isSumWithDiscounts"
                        label="Суммируется со скидками"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="editedItem.isSumWithUserDiscount"
                        label="Суммируется с накопительной скидкой"
                      ></v-checkbox>
<!--                      <v-checkbox-->
<!--                        v-model="editedItem.isPublic"-->
<!--                        label="Общий"-->
<!--                      ></v-checkbox>-->
                      <v-card>
                        <v-card-title>Не действует в категориях</v-card-title>
                        <v-card-text>
                          <category-select :open-dialog="dialog" :default="formatCategories(editedItem.exceptCategories)" @selected="addExpectCategories" />
                        </v-card-text>
                      </v-card>
                      <v-card>
                        <v-card-title>Действует в категориях</v-card-title>
                        <v-card-text>
                          <category-select :open-dialog="dialog" :default="formatCategories(editedItem.categories)" @selected="addCategories" />
                        </v-card-text>
                      </v-card>
                      <v-select
                        v-model="editedItem.status"
                        :items="statusList"
                        label="Статус"
                        single-line
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.image="{ item }">
          <v-img
            width="200px"
            height="200px"
            contain
            :src="`${getImage(item)}`"
          />
        </template>
        <template #item.status="{ item }">
          <p>{{ getStatus(item) }}</p>
        </template>
        <template #item.minOrderPrice="{ item }">
          <p>{{ item.minOrderPrice > 0 ? item.minOrderPrice : '' }}</p>
        </template>
        <template #item.maxOrderPrice="{ item }">
          <p>{{ item.maxOrderPrice > 0 ? item.maxOrderPrice : '' }}</p>
        </template>
        <template #item.isSumWithDiscounts="{ item }">
          <p>{{ item.isSumWithDiscounts ? 'Да' : 'Нет' }}</p>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { discounts, createDiscount, updateDiscount, deleteDiscount } from '@/graphql/discounts'
import { startCase } from 'lodash-es'
import CategorySelect from '@/components/offers/category-select'
import Relations from '@/components/press/relations'

export default {
  name: 'DiscountsList',
  components: {
    Relations,
    CategorySelect
  },
  layout: 'dashboard',
  apollo: {
    GetDiscounts: {
      query: discounts,
      variables () {
        return this.getBannersQueryVariables()
      },
      // update: data => data.bannerArea.items.data,
      result ({ data }) {
        if (data?.discounts?.data) {
          this.data = data.discounts.data
          this.totalCount = data.discounts.totalCount
        }
      },
      update (data) {
        return data.discounts.data
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      data: [],
      offersFormatted: [],
      selectedOffers: [],
      totalCount: 0,
      active: [],
      open: [],
      deleteDialog: false,
      dialog: false,
      newItem: true,
      filter: [],
      editedItem: {},
      statusList: [
        { value: 'ACTIVE', text: 'Активно' },
        { value: 'NOT_ACTIVE', text: 'Не активно' }
        // { value: 'DELETED', text: 'Удалено' }
      ],
      statusListConverter: { 1: 'PUBLISHED', 0: 'DRAFT', '-1': 'DELETED' },
      headers: [
        ['id', 'Id'],
        ['discountValue', 'Значение'],
        ['promoCode', 'Промокод'],
        // ['exceptCategories', 'Кроме категорий'],
        ['minOrderPrice', 'Мин. сумма заказа'],
        ['maxOrderPrice', 'Макс. сумма заказа'],
        ['isSumWithDiscounts', 'Суммируется со скидками'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
  },
  watch: {
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    formatPrice (price) {
      return price > 0 ? price : ''
    },
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    setImage (images) {
      this.editedItem.images = images
    },
    getImage (item) {
      if (item.images != null && item.images.length > 0) {
        return item.images[0].file?.url
      } else {
        return ''
      }
    },
    getBannersQueryVariables () {
      return {
        // filter: this.filter,
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      const input = {
        discountValue: this.editedItem.discountValue > 0 ? parseInt(this.editedItem.discountValue) : 0,
        promoCode: this.editedItem.promoCode,
        minOrderPrice: this.editedItem.minOrderPrice > 0 ? parseFloat(this.editedItem.minOrderPrice) : 0,
        maxOrderPrice: this.editedItem.maxOrderPrice > 0 ? parseFloat(this.editedItem.maxOrderPrice) : 0,
        isNthFreeDiscount: this.editedItem.isNthFreeDiscount,
        exceptCategories: this.editedItem.exceptCategories,
        categories: this.editedItem.categories,
        isSumWithDiscounts: this.editedItem.isSumWithDiscounts,
        isSumWithUserDiscount: this.editedItem.isSumWithUserDiscount,
        status: this.editedItem.status,
        // isPublic: this.editedItem.isPublic,
        moreThanNItems: this.editedItem.moreThanNItems ? parseInt(this.editedItem.moreThanNItems) : null,
        offers: this?.selectedOffers ?? []
      }
      if (this.newItem) {
        this.$apollo
          .mutate({
            mutation: createDiscount,
            variables: {
              input
            }
          })
          .then((data) => {
            this.$apollo.queries.GetDiscounts.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        const id = this.editedItem.id
        this.$apollo
          .mutate({
            mutation: updateDiscount,
            variables: {
              id,
              input
            }
          })
          .then((data) => {
            this.$apollo.queries.GetDiscounts.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
      }
      this.close()
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteDiscount,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.GetDiscounts.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.offersFormatted = item?.offers
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    addExpectCategories (cats) {
      this.editedItem.exceptCategories = cats.map(i => i.id.toString())
    },
    addCategories (cats) {
      this.editedItem.categories = cats.map(i => i.id.toString())
    },
    formatCategories (cats) {
      if (cats) {
        return cats.map(i => parseInt(i))
      }

      return cats
    },
    selectOffer (val) {
      this.selectedOffers = val
    }
  }
}
</script>

<style scoped>

</style>
